import React, { useEffect, useRef, useState } from "react";

// APP COMPONENTS
// MATERIAL UI COMPONENTS
import { getDeliveryOperators } from "../../api/deliveryOperator";
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const DeliveryOperatorFilter = ({ selectedValue, onFilterChange }) => {
  const loadDataAttempts = useRef(0);

  const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
  const [deliveryOperators, setDeliveryOperators] = useState([]);

  useEffect(() => {
    loadData().then((r) => r);
  }, []);

  const loadData = async () => {
    try {
      const res = await getDeliveryOperators();
      const operators_treated = res.data.map((operator) => {
        return {
          label: `${operator.first_name} ${operator.last_name}`,
          value: operator.id,
        };
      });

      if (operators_treated.length > 1) {
        operators_treated.unshift({
          label: "Todos",
          value: "ALL",
        });
      }
      setDeliveryOperators(operators_treated);
    } catch (e) {
      console.log(e);
      loadDataAttempts.current += 1;

      if (loadDataAttempts.current < 2) {
        // Retry if less than 2 attempts
        setTimeout(loadData, 1000); // Retry after 1 second
      }
    }
  };

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="delivery-operator-values"
      options={deliveryOperators}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Atendente"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

DeliveryOperatorFilter.displayName = "Operador";

export default DeliveryOperatorFilter;
